import { render, staticRenderFns } from "./SAccHomePage.vue?vue&type=template&id=1986ad60&scoped=true"
import script from "./SAccHomePage.vue?vue&type=script&lang=ts"
export * from "./SAccHomePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986ad60",
  null
  
)

export default component.exports